import { useEffect, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SignInForm } from '@/lib/auth/SignInForm';
import { clearIdleSignOutNotice, readIdleSignOutNotice } from '@/lib/auth/useReceptionIdleSignOut';

export const Route = createFileRoute('/sign-in/')({
  component: BusinessSignIn,
});

// `onSignedIn` is deliberately a no-op — see __root.tsx's isPublic branch
// for why navigating here (before the AuthProvider's deferred
// session-context update lands, per the ported deadlock workaround) races
// the root guard's own "no session yet" redirect back to /sign-in. The
// root guard's "signed in but on /sign-in" branch takes over once the
// session lands.
function BusinessSignIn() {
  // Follow-up F4 (decision 11): explain a reception idle sign-out.
  const [idleNotice] = useState(readIdleSignOutNotice);
  useEffect(() => {
    if (idleNotice) clearIdleSignOutNotice();
  }, [idleNotice]);

  return (
    <section className="rounded-card border border-border bg-surface p-xl shadow-card">
      <h1 className="text-screen-title font-extrabold tracking-tight text-ink">Sign in</h1>
      <p className="mt-xs text-body text-ink-2">Manage your NamibiaGo listings, bookings and check-ins.</p>
      {idleNotice ? (
        <p className="mt-md rounded-input bg-tint-info px-md py-sm text-body text-ink" role="status" data-testid="idle-sign-out-notice">
          You were signed out after 30 minutes without activity. Any check-in desk entries that had not synced
          are kept, encrypted, on this device and sync when you sign in again.
        </p>
      ) : null}
      <div className="mt-lg">
        <SignInForm allowSignUp onSignedIn={() => {}} />
      </div>
    </section>
  );
}
